module.exports = {"tag_close":"https://img13.360buyimg.com/imagetools/jfs/t1/161208/29/33187/730/637d8b2cEc6437a3e/8cc462637d2af61e.png"}


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/tag.json
// module id = 841
// module chunks = 418